exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layout[data-v-ed10eb26]{padding-top:15px;padding-bottom:15px}.layout.bg_white[data-v-ed10eb26]{background-color:#fff}.layout.bg_gray[data-v-ed10eb26]{background-color:#ededed}.layout_bottom[data-v-ed10eb26]{margin-bottom:27px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ed10eb26","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layout/Extra.vue
// module id = 25653354001ca4ec6bd6
// module chunks = 0